import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// External libraries
import { Avatar, Box, Paper, Skeleton, Typography, Link } from '@mui/material';
import Dotdotdot from 'react-dotdotdot';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';

// Internal modules
import common from '../../../utils/common';
import ConfigurationHelper from '../../../configuration/ClientConfigurationHelper';
import AmbassadorHelper from '../../../utils/AmbassadorHelper';
import { Analytics } from '../../../libs/analytics';

// UI components
import PlayIcon from '../../../ui/PlayIcon';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const isString = value => typeof value === "string";
const clearPrice = value => isString(value) ? value.replace(/[^\d.]/g, '') : value;
const formatPrice = (price) => {
    const options = {
        style: 'decimal',  // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    if (price && isString(price)) {
        if (price.indexOf("$") >= 0) {
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toLocaleString('en-US', options);
            return price.replace(onlyPrice, formattedPrice);
        } else {
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toLocaleString('en-US', options);
            return price.replace(onlyPrice, formattedPrice);
        }
    } else if (typeof price === "number") {
        return Number(price).toLocaleString('en-US', options);
    } else {
        return price
    }
}

class GridItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            products: [],
            ambassador: {}
        }
        this.arrowPrev = React.createRef();
        this.arrowNext = React.createRef();
    }

    componentDidMount() {
        this.setState({
            products: this.props.asset?.products || [],
            ambassador: this.props.asset?.creator || {},
        });
    }

    getAmbassadorUrl = () => {
        if (this.state.ambassador)
            return common.generateAmbassadorUrl(this.state.ambassador);
        else
            return "#";
    }
    getProductsMarkup = () => {
        const {products} = this.state;
        return products.map(this.getMarkupFromProduct);

    }
    renderPrice = (product) => {
        const {price_sale, price} = product;
        const currency_symbol = ConfigurationHelper.getCurrencySymbol();
        if (price === 0 || price == 0.00) return;
        let priceToShow = <Box sx={{minHeight: '35px'}}>
            { price && <Typography align={'center'} component={'div'} fontSize={'12px'}
                                                                    sx={{color: '#323232'}}
                                                                    lineHeight={'14px'}>{currency_symbol || "$"}{formatPrice(price)}
            </Typography>}
        </Box>
        if (!product.map && price_sale && price !== price_sale) {
            priceToShow = <Box sx={{minHeight: '35px'}}>
                <Typography align={'center'} component={'div'} fontSize={'12px'}
                                                                    sx={{color: '#323232'}}
                                                                    lineHeight={'14px'}>
                    {currency_symbol || "$"}{formatPrice(price_sale)}
                </Typography>
                <Typography component={'div'} align={'center'} fontSize={'10px'} lineHeight={'14px'}
                            sx={{color: '#727272'}}>
                    <strike>{currency_symbol || "$"}{formatPrice(price)}</strike>
                </Typography>
            </Box>
        }
        return <Box display={'flex'} justifyContent={'center'}>
            {priceToShow}
        </Box>
    }
    getMarkupFromProduct = (product) => {
        const {product_id, link, title, image} = product;
        const {asset} = this.props;
        const onClick= ()=>{
            Analytics.productClick({...product, id: product_id}, asset.id);
        }
        return <SwiperSlide key={product_id}>
            <Link type={'a'}
                key={product_id}
                href={common.addSharedIdToUrl(link, asset?.user_id, product_id)}
                underline={'none'}
                target={'_blank'}
                onClick={()=>onClick()}
            >
                <Box key={product_id} border={'1px solid #cccccc'} borderRadius={'4px'}>
                    <Box paddingTop={'100%'} overflow={'hidden'} position={'relative'} sx={{
                        '& img': {
                            maxHeight: '100%',
                            zIndex: -1,
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    }}>
                        <img src={image} alt={title}/>
                    </Box>
                    <Box>
                        {/*{this.renderPrice(product)}*/}
                    </Box>
                </Box>
            </Link>
        </SwiperSlide>;
    }

    getAspectRatio(content) {
        // calculate aspect ratio heigth / width
        if (content.entityType === 1)
            return "56.25%";
        else {
            const {asset} = content;
            const sourceImage = asset.sources && asset.sources ? asset.sources[0] : {}
            const aspectRatio = sourceImage.height / sourceImage.width;
            if (aspectRatio < 0.5626)
                return "56.25%";
            else if (aspectRatio >= 0.5626 && aspectRatio < 0.76)
                return "75%";
            else if (aspectRatio >= 0.76 && aspectRatio <= 1)
                return "100%";
            else if (aspectRatio > 1) {
                return "125%";
            }
        }
    }

    onLocalClickItem = (e) => {
        const {asset, index, redirect, onClickItem} = this.props;
        if (redirect === false) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof onClickItem === "function") {
                onClickItem({item: asset, index: index});
            }
        }
        return e;
    }

    render() {
        const {asset, mobileView, enableAmbassador} = this.props;
        const assetUrl = common.generateAssetUrl(asset);
        const ambassadorUrl = this.getAmbassadorUrl();
        const isVideo = asset.entityType && asset.entityType === 1;
        const sxH6 = {
            fontSize: "14px",
            lineHeight: "19px"
        }
        //DONT FORGET TO WORK ON THE ASPECT RATIO FOR IMAGES
        const products = this.getProductsMarkup();
        const thumbnail = common.getThumbnail(asset, mobileView);
        const {full_name} = asset.creator;
        const ambassadorAvatar = asset.creator ? AmbassadorHelper.getCreatorPhoto(asset.creator) : undefined;
        return <Box>

            <Paper square elevation={0}
                   sx={{height: "100%", "&:hover": {boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)"}}}>
                <Link href={enableAmbassador ? ambassadorUrl : assetUrl} color={"inherit"}
                      onClick={this.onLocalClickItem}
                      underline={"none"} sx={{
                    "&:hover, &:focus": {
                        textDecoration: 'none'
                    }
                }}>
                    <Box p={2} display="flex" alignItems="center">

                        <Box sx={{marginRight: theme => theme.spacing(1)}}>
                            <Avatar src={ambassadorAvatar} sx={{width: "32px", height: "32px"}} alt={full_name}/>
                        </Box>
                        <Typography sx={{...sxH6, fontWeight: 600}} variant={"h6"}>{
                            full_name ?
                                full_name :
                                <Skeleton width={"100%"} sx={{height: theme => theme.spacing(3)}} animation={"wave"}/>

                        }</Typography>

                    </Box>
                </Link>
                <Link href={assetUrl} underline={"none"}
                      onClick={this.onLocalClickItem}
                      sx={{
                          "&:hover, &:focus": {
                              textDecoration: 'none'
                          }
                      }}>
                    <Box sx={{
                        paddingTop: `${(mobileView ? this.getAspectRatio(asset) : "100%")}`,
                        position: "relative",
                        backgroundImage: `url(${thumbnail})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center"
                    }}>
                        {isVideo &&
                            <Box position="absolute" sx={{transform: "translate(-50%, -50%)", top: "50%", left: "50%"}}>
                                <PlayIcon sx={{width: "48px", height: "48px"}}/>
                            </Box>}
                        <Box position="absolute" borderRadius="2px" sx={{
                            left: theme => theme.spacing(2),
                            bottom: theme => theme.spacing(1)
                        }}>
                            <Box px={1} py={"4px"} color="#fff" display="flex" justifyContent="center"
                                 alignItems="center">
                            </Box>
                        </Box>
                    </Box>
                </Link>
                <Box mx={2} mt={2} position={'relative'}
                     sx={{
                         '& .swiper-slide': {
                             height: 'auto',
                             padding: 0
                         },
                         '& .swiper': {
                             overflow: 'hidden'
                         }
                     }}>
                    <Swiper
                        style={{
                            "--swiper-navigation-sides-offset": "0",
                            "--swiper-navigation-top-offset": "18px"
                        }}
                        autoHeight={true}
                        centeredSlides={true}
                        centeredSlidesBounds={true}
                        modules={[Navigation]}
                        navigation={{
                            prevEl: this.arrowPrev.current,
                            nextEl: this.arrowNext.current,
                        }}
                        onSwiper={(swiper) => {
                            swiper.on('slideChange', () => {
                                this.setState({ activeIndex: swiper.activeIndex });
                            });
                        }}
                        spaceBetween={'8px'}
                        slidesPerView={3.7}
                    >
                        {products}
                    </Swiper>
                    <Box
                        display={this.state.products.length < 4 ? 'none' : 'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        position={'absolute'}
                        top={0}
                        width={'100%'}
                        height={'100%'}
                        sx={{
                            '& .MuiSvgIcon-root': {
                                height: '100%',
                                cursor: 'pointer',
                                zIndex: 2,
                            },
                            '& .swiper-button-disabled': {
                                opacity: 0.3,
                                cursor: 'auto',
                                pointerEvents: 'none'
                            },
                        }}
                    >
                        <ChevronLeftIcon ref={this.arrowPrev} />
                        <ChevronRightIcon ref={this.arrowNext}/>
                    </Box>
                </Box>
                <Link href={assetUrl} underline={"none"}
                      onClick={this.onLocalClickItem}
                      sx={{
                          "&:hover, &:focus": {
                              textDecoration: 'none'
                          }
                      }}>
                    <Box p={2}>
                        <Typography sx={{...sxH6, fontWeight: 600}} gutterBottom fontSize={"14px"} variant={"h6"}>
                            <Dotdotdot clamp={1}>{asset.title}</Dotdotdot>
                        </Typography>
                        <Typography component={"div"}
                                    sx={{...sxH6, width: "100%"}}>
                            <Dotdotdot clamp={2}>
                                {asset.description}
                            </Dotdotdot>
                        </Typography>
                    </Box>
                </Link>
            </Paper>
        </Box>
    }
}

GridItem.defaultProps = {
    enableAmbassador: false,
    mobileView: false,
    maxDescriptionLines: 4,
    redirect: false

};
GridItem.propTypes = {
    asset: PropTypes.object.isRequired,
    mobileView: PropTypes.bool
}

export default GridItem;
